import {
  Grid,
  Box,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  ListItemSecondaryAction
} from "@mui/material";
import React, { useEffect, useState } from "react";
import Paper from "@mui/material/Paper";
import {CARD_CAPTION_STYLE, CARD_HEADER_STYLE, CARD_SUB_HEADER_STYLE} from "../../../../constants/Styles";
import {ContainedButton, TextButton, TooltipIconButton} from "../../../common/StyledButtons";
import {withRouter} from "react-router";
import {observer} from "mobx-react-lite";
import {getJobsForSite} from "../../../../actions/internal/JobActions";
import { getGroupedJobsBySiteId } from "../../../../selectors/JobSelectors";
import StyledStatusIcon from "../../../common/StyledStatusIcon";
import { JOB_GROUPS } from "../../../../constants/Statuses";
import StyledProgressCircle from "../../../common/StyledProgressCircle";
import { formatDateToFancyString } from "../../../../utilities/DateUtilities";
import { AssignmentOutlined } from "@mui/icons-material";
import Colors from "../../../../constants/Colors";
import StyledSection from "../../../common/StyledSection";

const ProjectsCard = ({ history, siteId }) => {

  const [ isLoading, setIsLoading ] = useState(true);

  const groupedJobs = getGroupedJobsBySiteId(siteId)

  useEffect(() => {
    loadData().then();
  }, [siteId])

  const loadData = async () => {
    try {
      setIsLoading(true);
      await getJobsForSite(siteId)
    } catch (ex) {
      console.error(ex);
    } finally {
      setIsLoading(false);
    }
  }

  const showLinkInNewTab = (url) => {
    const win = window.open(url, '_blank');
    win.focus();
  }

  const renderLoadingContent = () => (
    <StyledProgressCircle />
  )

  const renderNoProjectsSection = () => (
      <Box >
          <div style={CARD_HEADER_STYLE}>No projects, for now...</div>
          <p>Let's get something started! Set up a time with us to talk and get your business up and running on the web. Were you expecting to see something here, contact us and we'll get it sorted out.</p>
          <ContainedButton
            sx={{ padding: '8px 16px 8px 16px', marginTop: '10px' }}
            onClick={() => showLinkInNewTab('https://consultwithkyle.com/appointments') }
          >Start A Project</ContainedButton>
      </Box>
  )

  const getShowcasedJobs = () => {
    if (!groupedJobs) return null;
    const showcase = []
    if (groupedJobs[JOB_GROUPS.ACTION_REQUIRED]) showcase.push(...groupedJobs[JOB_GROUPS.ACTION_REQUIRED])
    if (groupedJobs[JOB_GROUPS.ACTION_REQUIRED]) showcase.push(...groupedJobs[JOB_GROUPS.ACTIVE])
    if (groupedJobs[JOB_GROUPS.ACTION_REQUIRED]) showcase.push(...groupedJobs[JOB_GROUPS.COMPLETED])
    return showcase.slice(0,3).sort((a, b) => b.job_metadata.created_at - a.job_metadata.created_at)
  }

  const renderJobsSection = (jobs) => (
    <>
    <Paper variant='outlined' sx={{ marginTop: '5px', paddingLeft: '10px', paddingRight: '10px' }}>
      <List style={{ flex: 1 }}>
          {jobs && jobs.map((job, index) => (
              <ListItem
              dense
              key={job.job_id}
              sx={{
                  backgroundColor: '#fff',
                  marginBottom: '5px',
                  borderBottom: index !== jobs.length - 1 ? '1px solid #e0e0e0' : 'none',
              }}
              >
              <ListItemAvatar>
                  <StyledStatusIcon status={job.job_details.job_status} sx={{ fontSize: '28px' }} />
              </ListItemAvatar>

              <ListItemText
                primary={job.job_details.job_name}
                secondary={`${job.job_details.job_description.substring(0, 120)}${job.job_details.job_description.length > 120 ? '...' : ''}`}
                sx={{ paddingRight: '48px' }} // add spacing to separate from the icon
              />

              <ListItemSecondaryAction>
                  <TooltipIconButton
                  text="View Details"
                  icon={
                      <AssignmentOutlined
                      sx={{ color: Colors.primaryColor }}
                      onClick={() => history.push(`/dashboard/site/${siteId}/projects/${job.job_id}`)}
                      />
                  }
                  />
              </ListItemSecondaryAction>
              </ListItem>
          ))}
          
          {(!jobs || jobs.length === 0) && <p>No active jobs.</p>}
      </List>
    </Paper>
    <Grid container justifyContent="flex-start" sx={{ marginTop: '18px'}}>
      <Grid item xs={12}>
        <ContainedButton
            sx={{ padding: '8px 16px 8px 16px' }}
            onClick={() => history.push(`/dashboard/site/${siteId}/projects`)}
          >View Projects</ContainedButton>
      </Grid>
    </Grid>
    </>
  )


  const renderJobCards = () => {
    const jobs = getShowcasedJobs();
    if (!jobs || jobs.length === 0) {
      return renderNoProjectsSection()
    }
    return renderJobsSection(jobs);

    /*const renderedJobs = jobs.map((job) => (
      <Grid item xs={12} sm={6} lg={4} key={job.job_id}>
        <Paper variant="outlined" sx={{ padding: '16px', position: 'relative', overflow: 'hidden' }}>
          <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', position: 'relative', zIndex: 15 }}>
            <div style={CARD_CAPTION_STYLE}>Project</div>
            <StyledStatusIcon status={job.job_details.job_status} sx={{ fontSize: '24px' }} />
          </Box>
          <Box>
            <h4 style={{ margin: 0, fontSize: '24px', marginTop: '8px' }}>{job.job_details.job_name}</h4>
            <div style={{...CARD_SUB_HEADER_STYLE, fontStyle: 'italic', fontSize: '16px' }}>{formatDateToFancyString(job.job_metadata.created_at)}</div>
            <p>{job.job_details.job_description.substring(0, 75)}{job.job_details.job_description.length > 75 ? '...' : ''}</p>
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', marginTop: '32px', position: 'relative', zIndex: 15}}>
            <TextButton onClick={() => history.push(`/dashboard/site/${siteId}/projects/${job.job_id}`)}>Details</TextButton>
          </Box>
        </Paper>
      </Grid>

    ))
    return (
      <Grid container justifyContent="flex-start" spacing={1}>
        {renderedJobs}
        <Grid item xs={12}>
          <ContainedButton
            sx={{ marginTop: '10px' }}
            onClick={() => history.push(`/dashboard/site/${siteId}/projects`)}
          >View All</ContainedButton>
        </Grid>
      </Grid>
    ) */
  }

  return (
    <StyledSection
        title="Recent Projects"
    >
       {isLoading ? renderLoadingContent() : renderJobCards() }
    </StyledSection>
  )
}

export default observer(withRouter(ProjectsCard));
